import React from 'react';
import {
  RequestedFeedbackContainer,
  FeedbackText,
  OpenFeedbackButton,
  FeedbackEmptyStateContainer,
  FeedbackEmptyStateTitle,
  FeedbackEmptyStateText,
  FeedbackTable as FeedbackTableContainer,
  EmptyStateButton,
} from 'src/tabs/styles/Feedback.styled';
import { FeedbackTableHeader } from '../FeedbackTableHeader/FeedbackTableHeader';
import { EmployeeFeedback } from 'src/tabs/models/FeedbackInterfaces';
import feedbackEmptyStateImage from 'src/assets/feedbackEmptyStateImage.png';
import { isMobile } from 'react-device-detect';
import { Add20Regular, OpenRegular } from '@fluentui/react-icons';

interface FeedbackTableProps {
  feedbacks: EmployeeFeedback[];
  selectedFeedbackId: string;
  clearForm: () => void;
  setSelectedEmployeeValues: React.Dispatch<
    React.SetStateAction<{
      requestedBy: string;
      employee: string;
    }>
  >;
  setSelectedTopic: (topic: string) => void;
  setSelectedFeedbackId: (feedbackId: string) => void;
  setMobileFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEmployeeId: (employeeId: string) => void;
  setOpenSubmitForm: React.Dispatch<React.SetStateAction<boolean>>;
}
export const FeedbackTable = ({
  feedbacks,
  selectedFeedbackId,
  clearForm,
  setSelectedEmployeeValues,
  setSelectedTopic,
  setSelectedFeedbackId,
  setMobileFormOpen,
  setSelectedEmployeeId,
  setOpenSubmitForm,
}: FeedbackTableProps) => {
  const onRequestFeedbackClick = (feedback: EmployeeFeedback) => {
    if (isMobile) {
      initializeFeedbackForm(feedback);
      setMobileFormOpen(true);
    }
  };

  const onOpenFeedbackClick = (feedback: EmployeeFeedback) => {
    initializeFeedbackForm(feedback);
    if (isMobile) {
      setMobileFormOpen(true);
    }
  };

  const initializeFeedbackForm = (feedback: EmployeeFeedback) => {
    clearForm();
    setSelectedEmployeeValues({
      requestedBy: feedback.cra0e_requester.new_name,
      employee: feedback.cra0e_employee.new_name,
    });
    setSelectedTopic(feedback.cra0e_topic.cra0e_feedbacktopicid);
    setSelectedFeedbackId(feedback.cra0e_employeefeedbackid);
    setSelectedEmployeeId(feedback.cra0e_employee.new_employeeid);
    setOpenSubmitForm(true);
  };

  const onSubmitNewFeedbackClick = () => {
    clearForm();
    setOpenSubmitForm(true);
    setMobileFormOpen(true);
  };

  return (
    <FeedbackTableContainer isBottomContainerVisible={feedbacks.length !== 0}>
      {feedbacks.length > 0 && isMobile && <FeedbackTableHeader />}
      {!isMobile && <FeedbackTableHeader />}
      {feedbacks && feedbacks.length ? (
        feedbacks?.map((feedback) => (
          <RequestedFeedbackContainer
            onClick={() => onRequestFeedbackClick(feedback)}
            key={feedback.cra0e_employeefeedbackid}
            isSelected={
              selectedFeedbackId === feedback.cra0e_employeefeedbackid
            }
          >
            <FeedbackText>
              <p>
                {isMobile
                  ? feedback.cra0e_employee.new_name
                  : feedback.cra0e_requester?.new_name || '-'}
              </p>
              {isMobile && (
                <p>Requested by {feedback.cra0e_requester?.new_name || '-'}</p>
              )}
            </FeedbackText>
            {!isMobile && (
              <FeedbackText>{feedback.cra0e_topic.cra0e_name}</FeedbackText>
            )}
            {!isMobile && (
              <FeedbackText>{feedback.cra0e_employee.new_name}</FeedbackText>
            )}
            <FeedbackText>{feedback.cra0e_duedate}</FeedbackText>
            <OpenFeedbackButton
              size="medium"
              iconPosition="before"
              icon={<OpenRegular />}
              onClick={() => onOpenFeedbackClick(feedback)}
            >
              {isMobile ? '' : 'Open'}
            </OpenFeedbackButton>
          </RequestedFeedbackContainer>
        ))
      ) : (
        <FeedbackEmptyStateContainer>
          <img src={feedbackEmptyStateImage} />
          <FeedbackEmptyStateTitle>
            Once you{`'`}ve received a request you{`'`}ll find it here
          </FeedbackEmptyStateTitle>
          <FeedbackEmptyStateText>
            Until then, feel free to submit feedback proactively by accessing
            the form here:
            <br />
          </FeedbackEmptyStateText>
          <EmptyStateButton
            appearance="primary"
            size="medium"
            icon={<Add20Regular />}
            iconPosition="before"
            onClick={onSubmitNewFeedbackClick}
          >
            Submit feedback
          </EmptyStateButton>
        </FeedbackEmptyStateContainer>
      )}
    </FeedbackTableContainer>
  );
};
